<template>
  <div class="userPage">
    <div class="user_info">
      <div class="user flex-rowl">
        <div class="tx flex-rowc">
          <van-image
            width="98%"
            height="98%"
            round
            :src="
              userInfo.headimg
                ? userInfo.headimg
                : require('../../assets/images/user-tx.png')
            "
          />
        </div>
        <div class="main">
          <!-- <div class="nick">
            {{ userInfo.nickname ? userInfo.nickname : "" }}
          </div> -->
          <div class="name">
            {{ userInfo.truename ? userInfo.truename : "" }}
          </div>
          <!-- <div class="leavel_accountId flex-rowl">
            <p>
              {{ userInfo.levelid ? "LV-" + userInfo.levelid : "" }} |
              {{ userInfo.attrname ? userInfo.attrname : "" }}
            </p>
            <p class="accountId">
              ID：{{ userInfo.accountid ? userInfo.accountid : "" }}
            </p>
            <div
              class="copy_box"
              :data-clipboard-text="userInfo.accountid"
              @click="handleCopyBtn()"
            >
              <i class="iconfont icon-fuzhi"></i>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="line"></div>

    <div class="base_info">
      <div class="tit">个人信息</div>
      <div class="base_info_list">
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-xingmingyonghumingnicheng"></i>
            </div>
            姓名：
          </div>
          <div class="txt2">{{ userInfo.truename }}</div>
        </div>
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-shoujihaoma"></i>
            </div>
            工作手机：
          </div>
          <div class="txt2">{{ tuozhan.mobile2 ? tuozhan.mobile2 : "" }}</div>
        </div>
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-weixin"></i>
            </div>
            工作微信：
          </div>
          <div class="txt2">{{ tuozhan.weixin ? tuozhan.weixin : "" }}</div>
        </div>
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-gender"></i>
            </div>
            企业名称：
          </div>
          <div class="txt2">
            {{ userInfo.companyname ? userInfo.companyname : "" }}
          </div>
        </div>
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-gender"></i>
            </div>
            性别：
          </div>
          <div class="txt2">{{ userInfo.sex ? userInfo.sex : "" }}</div>
        </div>
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-nianling"></i>
            </div>
            年龄：
          </div>
          <div class="txt2">{{ userInfo.age ? userInfo.age : "" }}</div>
        </div>
        <div class="base_info_item base_info_item_address">
          <div class="txt1 flex-rowl">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-weibiaoti-3"></i>
            </div>
            所在地区（日常活动范围）
          </div>
          <div class="txt">
            <p>
              <span v-if="PCA_address">{{ PCA_address }}</span>
              <span v-else class="place">省、市、自治区</span>
            </p>
            <p>
              <span v-if="userInfo.addr">{{ userInfo.addr }}</span>
              <span v-else class="place">区、街道、详细地址</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="apply_operation_wrap" v-if="cooperationQy.checkstate != 1">
      <div class="content">
        <div class="txt1">申请加入时间：</div>
        <div class="txt2">{{ cooperationQy.askdate | formatDate }}</div>
      </div>
      <div class="default_btn custom_btn" @click="handleAgree">
        同意加入申请 <i class="iconfont icon-duihao"></i>
      </div>
      <div
        class="remove_btn custom_btn"
        @click="handleRefuse"
        v-if="cooperationQy.checkstate != 2"
      >
        拒绝加入申请 <i class="iconfont icon-guanbi"></i>
      </div>
    </div>

    <div
      class="remove_btn custom_btn"
      @click="handleRemove"
      v-if="cooperationQy.checkstate == 1"
    >
      解除合作关系 <i class="iconfont icon-guanbi"></i>
    </div>

    <div class="block flex-colc">
      <p style="margin-bottom: 10px">是否允许合作快速发布商品</p>
      <van-radio-group v-model="isquick" direction="horizontal">
        <van-radio name="1">是</van-radio>
        <van-radio name="0">否</van-radio>
      </van-radio-group>
    </div>

    <div class="block flex-colc">
      <p style="margin-bottom: 10px">设置关联品牌</p>
      <van-checkbox-group v-model="brandguidArr" direction="horizontal">
        <van-checkbox name="">无</van-checkbox>
        <van-checkbox
          v-for="(item, index) in brandList"
          :key="index"
          :name="item.id"
          >{{ item.labelname }}</van-checkbox
        >
      </van-checkbox-group>
      <div class="custom_btn" @click="query" v-if="cooperationQy.checkstate == 1">确认</div>
      <div class="custom_btn return" @click="handlereturn">
        <i class="iconfont icon-yuyinjiantou"></i> 返回
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
// import { getUserInfo } from "../../api/api";
import { encryptstringview, getBrandList } from "../../api/api";
import {
  refuseCooperationQy,
  agreeCooperationQy,
  removeCooperationQy,
  getCooperationQyDetail,
  updateIsquick,
} from "../../api/company";
import { mapState } from "vuex";
export default {
  name: "companyUserDetail",
  data() {
    return {
      isShow: false,
      department: "",
      departmentId: "",
      role: "",
      roleId: "",

      PCA_address: "", // 省、市、区
      userInfo: "",
      tuozhan: "",
      works: "",
      qy: "",

      id: "", // 用户id
      openid: "", // 用户openid
      cooperationQy: "", // 合作商家
      isquick: "0", // 是否允许快速发布商品 1=允许 0允许
      brandguidArr: [],

      brandList: "", // 品牌列表
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  created() {
    let { routerList, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.getBrandList(USERINFO.qy.qyguid);
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { openid, id } = JSON.parse(res.jsondata);
        this.id = id;
        this.openid = openid;
        this.getCooperationQyDetail();
      } else {
        this.$router.back();
      }
    },
    getBrandList(qyguid) {
      getBrandList({ keyword: "", qyguid }).then((res) => {
        let filterRes = res.filter((v) => v.labelstate == 1);
        this.brandList = filterRes;
      });
    },

    // 获取
    getCooperationQyDetail() {
      getCooperationQyDetail({ id: this.id }).then((res) => {
        this.cooperationQy = res;

        let newUser = res.user;
        this.userInfo = newUser;
        this.PCA_address =
          (newUser.provincename ? newUser.provincename : "") +
          " " +
          (newUser.cityname ? newUser.cityname : "") +
          " " +
          (newUser.areaname ? newUser.areaname : "");
        this.tuozhan = newUser.ext ? newUser.ext : "";
        this.works =
          newUser.ams_farming_user_works.length == 0
            ? ""
            : newUser.ams_farming_user_works[0][0];
        this.qy = newUser.qy;
        this.department = newUser.deptname;
        this.departmentId = newUser.deptid;
        this.role = newUser.rolename;
        this.roleId = newUser.roleid;
        this.isquick = res.isquick ? res.isquick : "0";
        this.brandguidArr = res.brandguid
          ? res.brandguid.split(",").map(Number)
          : [];
      });
    },

    // 同意
    handleAgree() {
      // const toast = this.$toast.loading({
      //   message: "提交中...",
      //   forbidClick: true,
      // });
      let { id, openid, cooperationQy } = this;
      agreeCooperationQy({
        id,
        openid,
        qyid: cooperationQy.qyid,
        checkstate: 1,
      }).then((res) => {
        if (res.result) {
          this.query(true)
          // toast.clear();
          // this.$toast.success(res.message);
          // setTimeout(() => {
          //   this.$router.back();
          // }, 1500);
        } else {
          this.$toast.fail(res.message);
          // toast.clear();
        }
      });
    },

    // 拒绝
    handleRefuse() {
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      let { id, openid, cooperationQy } = this;
      refuseCooperationQy({
        id,
        openid,
        qyid: cooperationQy.qyid,
        checkstate: 2,
      }).then((res) => {
        if (res.result) {
          toast.clear();
          this.$toast.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message);
          toast.clear();
        }
      });
    },

    // 移出合作商家
    handleRemove() {
      this.$toast("即将开放");
      // this.$dialog
      //   .confirm({
      //     message: "是否确定移出该合作商家",
      //   })
      //   .then(() => {
      //     this.removeCooperationQy();
      //   })
      //   .catch(() => {
      //     // on cancel
      //     console.log("2222");
      //   });
    },
    removeCooperationQy() {
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      removeCooperationQy({ id: this.id }).then((res) => {
        if (res.result) {
          toast.clear();
          this.$toast.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message);
        }
      });
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },

    query() {
      let { id, openid, cooperationQy, isquick, brandguidArr } = this;
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      updateIsquick({
        id,
        openid,
        qyid: cooperationQy.qyid,
        isquick,
        brandguid: brandguidArr.join(","),
      }).then((res) => {
        if (res.result) {
          toast.clear();
          this.$toast.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          toast.clear();
        }
      });
    },

    // 返回上一页
    handlereturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.userPage {
  padding-bottom: 350px;
  background: #fafafa;
  .dialog_wrapper {
    padding: 80px 50px;
    box-sizing: border-box;
    .select_box {
      width: 100%;
      margin-bottom: 40px;
    }
  }
  .user_info {
    padding: 45px 40px 0;
    margin: auto;
    background: #fff;
    .tx {
      width: 140px;
      height: 140px;
      border: 5px solid #f0f0f0;
      box-sizing: border-box;
      border-radius: 50%;
      // overflow: hidden;
      margin-right: 25px;
      position: relative;
      .edit {
        position: absolute;
        bottom: 7px;
        right: 9px;
        background: #f0f0f0;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        .iconfont {
          font-size: 12px;
        }
      }
    }
    .main {
      flex: 1;
      .nick {
        font-size: 22px;
        color: #828282;
      }
      .name {
        font-size: 30px;
        color: #3c3c3c;
        margin: 12px 0 14px;
      }
      .leavel_accountId {
        font-size: 16px;
        color: #aaaaaa;
        .accountId {
          margin: 0 13px 0 45px;
        }
      }
    }
  }
  .line {
    background: url(../../assets/images/mime_line.png) no-repeat center;
    background-size: cover;
    width: 750px;
    height: 86px;
  }

  .base_info {
    background: #fff;
    padding: 29px 83px 100px;
    box-sizing: border-box;
    font-size: 24px;
    color: #333333;
    margin-bottom: 80px;
    .tit {
      font-size: 30px;
      margin-bottom: 60px;
    }
    .base_info_item {
      margin-bottom: 60px;
      &.base_info_item_address {
        .txt {
          margin-left: 40px;
          p {
            margin: 20px 0;
            .place {
              color: #969799;
            }
          }
        }
      }
    }
  }

  .depar_role_wrap {
    margin: 30px 0 90px;
    background: #fff;
    padding: 50px 75px 80px;
    box-sizing: border-box;
    .tit {
      font-size: 30px;
      color: #333333;
      margin-bottom: 80px;
    }
    .select {
      border-bottom: 1px dashed #c3c3c3;
      height: 60px;
      margin-bottom: 40px;
      &:last-child {
        margin-bottom: 0;
      }
      .icon-yuyinjiantou {
        transform: rotate(-90deg);
        font-size: 30px;
      }
    }

    /deep/ .van-cell {
      padding: 0 14px !important;
      font-size: 12px;
    }
  }
  .apply_operation_wrap {
    padding: 80px 0 115px 0;
    box-sizing: border-box;
    border-bottom: 30px solid #fff;
    margin-bottom: 50px;
    .content {
      // padding-left: 82px;
      box-sizing: border-box;
      font-size: 30px;
      color: #333333;
      text-align: center;
      .txt2 {
        font-size: 22px;
        margin-top: 25px;
      }
    }
    .default_btn {
      margin: 84px auto 57px;
    }
  }
  .save {
    color: #fff;
    margin-top: 100px;
    width: 280px;
    height: 50px;
    line-height: 50px;
  }
  .remove_btn {
    border: 1px solid #e6e6e6;
    color: #373737;
    background: #fff;
    margin-bottom: 40px;
  }
  .block {
    font-size: 24px;
    color: #333333;
    margin-top: 120px;
    .custom_btn {
      margin-top: 40px;
    }
  }
}
</style>